import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const VisaLogo = ({ style }: SVGIconProps) => (
  <Center style={style}>
    <svg viewBox="286 206 86 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="m322.375 208.457-10.472 25.145h-6.835l-5.149-20.065c-.317-1.237-.588-1.688-1.539-2.213-1.557-.847-4.118-1.642-6.38-2.137l.158-.73h10.997c1.402 0 2.663.942 2.98 2.564l2.723 14.554 6.726-17.118h6.791Zm26.773 16.932c.031-6.633-9.12-6.994-9.055-9.961.018-.906.871-1.865 2.74-2.107.927-.124 3.481-.215 6.375 1.122l1.134-5.33c-1.557-.568-3.559-1.113-6.046-1.113-6.389 0-10.887 3.42-10.925 8.312-.041 3.619 3.209 5.638 5.661 6.843 2.518 1.233 3.36 2.02 3.351 3.126-.016 1.687-2.009 2.425-3.867 2.458-3.251.051-5.136-.884-6.642-1.589l-1.171 5.512c1.509.697 4.301 1.302 7.191 1.338 6.791 0 11.233-3.383 11.254-8.611Zm16.872 8.213H372l-5.218-25.145h-5.52c-1.241 0-2.287.728-2.753 1.844l-9.694 23.301h6.785l1.347-3.755h8.294l.779 3.755Zm-7.213-8.909 3.404-9.441 1.958 9.441h-5.362Zm-27.194-16.236-5.348 25.145h-6.466l5.35-25.145h6.464Z"
      />
    </svg>
  </Center>
);
